import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    ShowButton,
    usePermissions,
    EditButton,
    TextInput,
    ReferenceField,
    TopToolbar,
    FilterButton,
    ExportButton,
    UrlField
} from 'react-admin';
import { permissionManager } from "../permissions/manager";

const companyFilters = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="Base Url" source="base_url" name="base_url" />,
    <TextInput label="Company" source="company" name="company" />,
];

const ListActions = () => {
    const { permissions } = usePermissions();
    return(
        <TopToolbar>
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const AdminWebsiteList = () => {
    const {permissions} = usePermissions();
    return (
        <List
            actions={<ListActions/>}
            filters={companyFilters}>
            <Datagrid bulkActionButtons={false}>
                <TextField source="id"/>
                <UrlField source="baseUrl" target="_blank"/>
                <ReferenceField
                    source="company"
                    reference="companies"
                    link="edit"
                >
                    <TextField source="name"/>
                </ReferenceField>

                <>
                    <ShowButton/>
                    <EditButton/>
                </>
            </Datagrid>
        </List>
    );
}